import requestor from "shared/service/requestor";

export default class TreeNodeApi {
  constructor(isManage = false) {
    this.namespace = isManage ? '/manage/course_' : '/course/';
  }
  all = (courseId) => requestor.get(this.namespace + "tree-node-all", { course_id: courseId });
  create = (form) => requestor.post(this.namespace + "tree_node_create", form);
  save = (courseId, form) => requestor.patch(this.namespace + "tree_node_save", { course_id: courseId, CourseTreeNode: form });
  delete = (courseId, id) => requestor.delete(this.namespace + "tree_node_delete", { course_id: courseId, id: id });
  toggle = (courseId, id) => requestor.patch(this.namespace + "tree_node_toggle", { course_id: courseId, id: id });
}
